var path = 'app/scripts/modules/ecs/serverGroup/configure/wizard/advancedSettings/advancedSettings.html';
var html = "<div class=\"clearfix\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <ecs-server-group-advanced-settings command=\"command\" application=\"application\"></ecs-server-group-advanced-settings>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/ecs/serverGroup/configure/wizard/advancedSettings/advancedSettings.html
// module id = 1615
// module chunks = 0